/**
 * 알림톡 종류를 사람이 읽는 말로 바꾸는 이름표.
 *
 * 🔴 왜 한 곳에 모았나
 * 종전엔 화면마다 따로 갖고 있어서(사용량 분석 / 본부 청구 / 거래명세서) 같은 알림이
 * 화면마다 다른 이름으로 나오거나, 아예 `study_report_001` 같은 코드가 그대로 보였다.
 * 원장이 물어볼 때 서로 다른 이름이 나오면 안 되므로 여기 하나만 고친다.
 *
 * 서버의 `alimtalk_billing_service.TYPE_LABELS` 와 짝이다. 한쪽만 고치지 말 것.
 *
 * 같은 알림이 **서식코드**(entry_exit_001)와 **종류**(gate_entry_exit) 두 이름으로
 * 들어올 수 있어 양쪽을 모두 적는다.
 */
export const ALIMTALK_TYPE_LABELS: Record<string, string> = {
  // 출입
  entry_exit_001: '입·퇴실 알림',
  gate_entry_exit: '입·퇴실 알림',
  entry: '입실 알림',
  exit: '퇴실 알림',

  // 출결
  absent_student_alert: '미출석 알림',
  schedule_change_001: '스케줄 변경',
  student_not_returned_001: '학원 미복귀 알림',

  // 사유서
  exception_review_001: '사유서 제출',
  exception_apprv_001: '사유서 승인',

  // 이용권
  ticket_expiry_001: '이용권 만료 예정',
  ticket_expiry: '이용권 만료 예정',
  EXPIRY_D7: '만료 7일 전',
  EXPIRY_D3: '만료 3일 전',
  EXPIRY_D1: '만료 1일 전',
  EXPIRY_D0: '만료 당일',

  // 벌점
  penalty_issued_001: '벌점 확정',
  penalty_preview_001: '벌점 예고',
  patrol_penalty_alert: '순찰 벌점',
  patrol_penalty_002: '순찰 벌점',

  // 리포트·기타
  study_report_001: '학습 리포트',
  study_report_002: '학습 리포트',
  phone_verification_0: '본인인증',
  parent_invite_0: '학부모 초대',
  credit_low_001: '잔액 부족 안내',
  payment_complete: '결제 완료',
  PAYMENT_COMPLETE: '결제 완료',
  MANUAL: '수동 발송',
};

/** 모르는 종류면 코드를 그대로 보여준다 — 조용히 감추지 않는다. */
export const alimtalkTypeLabel = (code?: string | null): string =>
  (code && ALIMTALK_TYPE_LABELS[code]) || code || '알 수 없음';
